<div class="d-flex flex-column flex-md-row text-center text-md-start justify-content-between py-2 px-3 px-xl-4">
  <!-- Copyright -->
  <div class=" mb-3 mb-md-0">
    Copyright © 2021. All rights reserved @AM Developers.
  </div>
  <!-- Copyright -->

  <!-- Right -->
  <div>
    <a href="#!" class="text-white me-4">
      <i class="fab fa-facebook-f"></i>
    </a>
    <a href="#!" class="text-white me-4">
      <i class="fab fa-twitter"></i>
    </a>
    <a href="#!" class="text-white me-4">
      <i class="fab fa-google"></i>
    </a>
    <a href="#!" class="text-white">
      <i class="fab fa-linkedin-in"></i>
    </a>
  </div>
  <!-- Right -->
</div>